import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Terminal, ShieldCheck, ArrowUpRight } from "lucide-react";

export const NAV_LINKS = [
  ["Work", "/work", "nav-work-link"],
  ["Security", "/security", "nav-security-link"],
  ["Services", "/services", "nav-services-link"],
  ["About", "/about", "nav-about-link"],
  ["Contact", "/contact", "nav-contact-link"],
];

export default function Navbar({ onOrder }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    fn();
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`anim-reveal nav-in fixed top-0 inset-x-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto h-16 sm:h-20 flex items-center justify-between">
        <Link data-testid="nav-logo-link" to="/" className="flex items-center gap-2.5 group" aria-label="CODELANK home">
          <span className="w-8 h-8 rounded-md bg-cyan-400/10 border border-cyan-400/40 flex items-center justify-center group-hover:bg-cyan-400/20 transition-colors duration-300" aria-hidden="true">
            <Terminal className="w-4 h-4 text-cyan-400" />
          </span>
          <span className="font-display font-bold tracking-tight text-lg">
            CODE<span className="text-cyan-400">LANK</span>
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(([label, to, testid]) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-cyan-400 ${isActive ? "text-cyan-400" : "text-slate-400"}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            data-testid="nav-admin-login-button"
            to="/admin"
            rel="nofollow"
            className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-mint hover:border-mint/40 transition-colors duration-300"
            title="Admin access"
            aria-label="Admin access"
          >
            <ShieldCheck className="w-4 h-4" aria-hidden="true" />
          </Link>
          <button
            data-testid="nav-order-cta-button"
            onClick={() => onOrder()}
            className="group flex items-center gap-1.5 rounded-full bg-cyan-400 text-[#030308] font-semibold text-sm px-5 py-2.5 hover:bg-mint transition-colors duration-300"
          >
            Start Order
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" aria-hidden="true" />
          </button>
        </div>
      </div>
    </header>
  );
}
